import { withErrorBoundary } from '@sentry/react'
import { useContext } from 'react'

import ScreenContext from 'src/context/screenContext'
import useSidebar from 'src/utils/hooks/use-sidebar'

import SentryFallback from '../SentryFallback'
import CollapsedSidebar from './collapsedSidebar'
import Sidebar from './sidebar'

const Navigator = () => {
    const { sidebarCollapsed } = useSidebar()
    const { isSmallScreen } = useContext(ScreenContext)

    if (isSmallScreen) {
        if (sidebarCollapsed) {
            return null
        } else {
            return <Sidebar />
        }
    } else {
        if (sidebarCollapsed) {
            return <CollapsedSidebar />
        } else {
            return <Sidebar />
        }
    }
}

export default withErrorBoundary(Navigator, {
    fallback: <SentryFallback />,
})
